import classNames from "classnames/bind";
import styles from "./ModalAddCamera.module.css";
import { useEffect, useRef, useState } from "react";
import { Button, Chip, Col, HeaderModal, Row, SearchSelect, SelectBox, SelectBoxItem, Toast } from "../../../../../components";
import { convertTimePM } from "../../../../../utils";
import DateTimePicker from "../../../../../components/DateTimePicker/DateTimePicker";

const cx = classNames.bind(styles);

function ModalAddCamera({ onClose, isShow }) {
    const [search, setSearch] = useState("")
    const refModal = useRef(null);
    const ref = useRef(null);
    const refBtn = useRef(null);
    const [loading, setLoading] = useState(false);
    const [isFormTime, setIsFormTime] = useState(false);
    const [formInfoCam, setFormInfoCam] = useState({
        cameraName: '',
        timeStartApply: '',
        timeEndApply: '',
        status: 1,
        timeStart: new Date(),
        timeEnd: new Date(),
    })

    const handleSearch = (e, value) => {
        if (e) {
            // // console.log(e, value);
        } else {
            setSearch(value)
        }
    }

    const handleSubmitAddCam = async () => {
        try {
            // doing smt
        } catch (error) {
            Toast.open("Thêm camera không thành công", "danger")
        }
    }

    const handleChangeFormInfo = (key, value) => {
        setFormInfoCam(prev => ({ ...prev, [key]: value }))
    }

    useEffect(() => {
        const handleCloseOnClickOutSide = (e) => {
            if (e.target === refModal.current) {
                onClose()
            }
        }
        document.addEventListener('click', handleCloseOnClickOutSide)
        return () => { document.removeEventListener('click', handleCloseOnClickOutSide) }
    }, [])

    useEffect(() => {
        let handler = (e) => {
            if (!refBtn?.current?.contains(e.target)) {
                if (!ref?.current?.contains(e.target)) {
                    setIsFormTime(false);
                }
            }
        };
        document.addEventListener("click", handler);
        return () => {
            document.removeEventListener("click", handler);
        };
    }, []);
    return (
        <>
            {isShow ? <div className={cx("wrapper")} ref={refModal}>
                <div className={cx('content')} >
                    <HeaderModal title={"Thêm mới camera sử dụng dịch vụ"} onClose={onClose} />
                    <div className={cx('body')}>
                        <Row gap={[8, 8]}>
                            <Col span={6}>
                                <SearchSelect
                                    onChange={handleSearch}
                                    placeholder={"Tên camera"}
                                    value={search}
                                    label={'Tên camera'}
                                />
                            </Col>
                            <Col span={6}>
                                <div
                                    style={{ cursor: "pointer", position: "relative" }}
                                    className={cx("item-setting")}
                                >
                                    <span
                                        className={cx("info")}
                                        onClick={() => {
                                            setIsFormTime(!isFormTime);
                                        }}
                                    >
                                        <span ref={refBtn} className={cx("list-time")}>
                                            <label className={cx("label-timeApply")}>Giờ áp dụng</label>
                                            <div className={cx("timeApply")}>
                                                {`${convertTimePM(formInfoCam.timeStartApply)} - ${"12:12" === "00" ? "24" : convertTimePM(formInfoCam.timeEndApply)}`}
                                            </div>
                                        </span>
                                    </span>
                                    {isFormTime && (
                                        <div ref={ref} className={cx("time")}>
                                            <div className={cx("start")}>
                                                <label className={cx("label-time")}>Giờ bắt đầu</label>
                                                <input
                                                    onChange={(e) => handleChangeFormInfo('timeStartApply', e.target.value)}
                                                    className={cx("input-time")}
                                                    type={"time"}
                                                    value={formInfoCam.timeStartApply}
                                                />
                                            </div>
                                            <div
                                                onChange={(e) => e}
                                                className={cx("end")}
                                            >
                                                <label className={cx("label-time")}>Giờ kết thúc</label>
                                                <input
                                                    value={formInfoCam.timeEndApply}
                                                    className={cx("input-time")}
                                                    type={"time"}
                                                    onChange={(e) => handleChangeFormInfo('timeEndApply', e.target.value)}
                                                />
                                            </div>
                                            <div className={cx('foolter_time')}>
                                                <Button className={cx('apply_time')} title={"Xong"} onClick={() => setIsFormTime(!isFormTime)} />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col span={6}>
                                <DateTimePicker title={"Ngày bắt đầu"} />
                            </Col>
                            <Col span={6}>
                                <DateTimePicker title={"Ngày kết thúc"} />
                            </Col>
                            <Col span={6}>
                                <SelectBox type="small" title={"Trạng thái"}>
                                    <SelectBoxItem />
                                </SelectBox>
                            </Col>
                        </Row>
                    </div>
                    <div className={cx('foolter')}>
                        <Button title={"Hủy"} type={"danger"} className={cx('cancel')} onClick={onClose} />
                        <Button title={"Thêm mới"} type={"primary"} className={cx('oke')} onClick={handleSubmitAddCam} />
                    </div>
                </div>
            </div> : <></>}
        </>
    )
}

export default ModalAddCamera;